module.exports = __webpack_public_path__ + "06_medium_grey.e8480c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_medium_grey.png
// module id = hZn8
// module chunks = 0